/**
 * 项目 basePath 前缀
 * 用于 CSS url()、inline style background、favicon 等不会被 Next.js 自动加 basePath 的场景
 * Next.js <Image>、<Link> 组件会自动处理，不需要用这个
 */
const BASE_PATH = "/pointsmall";

export default BASE_PATH;
